import { usStates } from '@/utilities/states'

import type { USState } from '@/utilities/states'

const STATE_VALUES = new Set<string>(usStates.map((state) => state.value))

/**
 * Parses a US state abbreviation or full name into a two-letter `USState`.
 * Returns null when the value is missing or not in the supported list.
 */
export function parseUSState(value: string | null | undefined): USState | null {
  const trimmed = value?.trim()
  if (!trimmed) return null

  const upper = trimmed.toUpperCase()
  if (STATE_VALUES.has(upper)) return upper as USState

  const byLabel = usStates.find((state) => state.label.toUpperCase() === upper)
  return byLabel ? (byLabel.value as USState) : null
}
